import React from 'react';

const SvgDiamondLegend = (props) => (
  <svg width={20} height={12} {...props}>
    <g fill="none">
      <rect width={20} height={1} y={5.5} fill={props.color} rx={0.5} />
      <path
        fill="#FFF"
        stroke={props.color}
        strokeWidth={2}
        d="M10.338 1.757L14.581 6l-4.243 4.242L6.095 6z"
      />
    </g>
  </svg>
);

export default SvgDiamondLegend;
